import { CreateRunRequestModel } from "models/CreateRunRequestModel";
import { CreateRunResultModel } from "models/CreateRunResultModel";
import { createContext } from "react";

export interface EdecideDocument {
  id?: number;
  name?: string;
  url?: string;
  iconClass?: string;
}

export interface EdecidePanelContextProps {
  isOpen: boolean;
  isLoading: boolean;
  isPreview: boolean;
  isResult: boolean;
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
  runTitle: string;
  runPreview: CreateRunRequestModel | null;
  runResult: CreateRunResultModel | null;
  error: Error | null;
  openEdecidePanel: (document?: EdecideDocument | null) => void;
  closeEdecidePanel: () => void;
  setRunTitle: (title: string) => void;
  submitEdecidePanel: () => void;
}

export const EdecidePanelContext = createContext({} as EdecidePanelContextProps);
